<template>
    <div v-in-viewport="fetchData">
        <graph-title
            :description="$t('analytics.info.application_reject_reasons.description').toString()"
            :title="$t('analytics.info.application_reject_reasons.title').toString()"
        />
        <div>
            <div v-if="fetching" class="h-336 w-full flex items-center justify-center">
                <loading color="blue" size="small"></loading>
            </div>
            <div v-else>
                <div v-if="seriesDataLength">
                    <div class="h-full relative">
                        <apex-charts
                            ref="applicationRejectReasons"
                            :height="75 + seriesDataLength * 30"
                            :options="chartOptions"
                            :series="series"
                            type="bar"
                            width="100%"
                        ></apex-charts>
                        <pagination
                            v-if="totalPages > 1"
                            :items-per-page="defaultDataThreshold"
                            :total-items="graphData.count"
                            @next="currentPage++"
                            @prev="currentPage--"
                            @go-to="currentPage = $event + 1"
                        />
                    </div>
                </div>
                <div v-else class="flex flex-col px-10">
                    <span class="text-center italic my-16">{{ $t('analytics.empty_series') }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as analytics from "../../services/AnalyticsService";
import AnalyticsMixins from "../../mixins/analyticsMixins";
import GraphTitle from "./GraphTitle";
import ApexCharts from "vue-apexcharts";
import chartOptions from '../../config/apex-charts';
import Loading from "../ui/Loading";
import SvgIcon from '../ui/SvgIcon';
import Pagination from "../navigation/FlatPagination.vue";

export default {
    components: {
        Loading,
        ApexCharts,
        SvgIcon,
        GraphTitle,
        Pagination,
    },
    mixins: [AnalyticsMixins],
    props: {
        filterFields: Object,
    },
    data() {
        return {
            chartOptions: {
                ...chartOptions,
                colors: ['#FF4560'],
            },
        }
    },
    methods: {
        async fetchData(fresh = true) {
            if (!this.sendRequest() && !fresh) {
                this.fetching = false;
                return;
            }
            return await analytics.applicationRejectReasons(this.filterFields).then(response => {
                this.graphData = response;
            }).then(() => this.buildChart());
        },
        buildChart() {
            this.series = this.getPageData();
            this.fetching = false;
            this.$nextTick(() => {
                this.graphRef = this.$refs.applicationRejectReasons
                this.setDownloadButtonId(this.graphRef, 'downloadChartApplicationRejectReasons')
            })
        },
    },
}
</script>
